module.exports = __webpack_public_path__ + "static/media/smelter.b3b051a0.png";